import { WireGuardTunnel } from "./SiteAboutPageUtils/siteAboutInterfaces";

type WireGuardOption = {
  id: number;
  name: string;
  zone: string;
  server_public_key?: string;
};

export const resolveWireguardServerEndpoint = (
  serverId: number,
  options: WireGuardOption[]
): string => {
  const match = options.find((o) => o.id === serverId);
  if (!match) {
    return "—";
  }
  return match.zone ? `${match.name} (${match.zone})` : match.name;
};

/**
 * The tunnel's gateway public key, which the customer needs for the [Peer] block
 * on their side.
 *
 * The tunnel endpoints never return it — `WireGuardTunnelSerializer` exposes only
 * the numeric `server` id — so it is resolved from the server list that
 * `GET wireguard/` already loads into `appStore.wireGuardOptions` at login.
 */
export const resolveWireguardServerPublicKey = (
  serverId: number,
  options: WireGuardOption[]
): string => {
  const match = options.find((o) => o.id === serverId);
  return match?.server_public_key || "—";
};

export const formatWireguardLastHandshake = (
  iso: string | null | undefined
): string => {
  if (iso == null || iso === "") {
    return "—";
  }
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) {
    return iso;
  }
  return d.toLocaleString();
};

export const getSelectedWireguardTunnel = (
  tunnels: WireGuardTunnel[],
  selectedId: number | null
): WireGuardTunnel | null => {
  if (tunnels.length === 0) {
    return null;
  }
  if (selectedId != null) {
    const found = tunnels.find((t) => t.id === selectedId);
    if (found) {
      return found;
    }
  }
  return tunnels[0];
};
